import { render } from "./AutoPoolStake.vue?vue&type=template&id=5412edc5"
import script from "./AutoPoolStake.vue?vue&type=script&lang=js"
export * from "./AutoPoolStake.vue?vue&type=script&lang=js"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__